(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dv-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const mountCarousel = (root = document) => {
      root.querySelectorAll('[data-dv-community-carousel]').forEach((carousel) => {
        if (carousel.dataset.dvCarouselReady) return;
        carousel.dataset.dvCarouselReady = 'true';

        const track = carousel.querySelector('.dv-community-gallery__grid');
        const move = (direction) => {
          const card = track.querySelector('.dv-community-gallery__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
        };

        carousel.querySelector('[data-dv-carousel-previous]')?.addEventListener('click', () => move(-1));
        carousel.querySelector('[data-dv-carousel-next]')?.addEventListener('click', () => move(1));
      });
    };

    const mountVideos = (root = document) => {
      root.querySelectorAll('[data-dv-community-video]').forEach((video) => {
        if (video.dataset.dvVideoReady) return;
        video.dataset.dvVideoReady = 'true';

        const button = video.parentElement.querySelector('[data-dv-video-toggle]');
        let manuallyPaused = false;

        const setButton = () => {
          if (!button) return;
          button.textContent = video.paused ? '▶' : '❚❚';
          button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        };

        button?.addEventListener('click', () => {
          if (video.paused) {
            manuallyPaused = false;
            video.play().catch(() => {});
          } else {
            manuallyPaused = true;
            video.pause();
          }
          setButton();
        });

        video.addEventListener('play', setButton);
        video.addEventListener('pause', setButton);
        setButton();

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !manuallyPaused && !reduceMotion.matches) {
              entry.target.play().catch(() => {});
            } else {
              entry.target.pause();
            }
          });
        }, { threshold: 0.55 });

        observer.observe(video);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        mountCarousel();
        mountVideos();
      }, { once: true });
    } else {
      mountCarousel();
      mountVideos();
    }

    document.addEventListener('shopify:section:load', (event) => {
      mountCarousel(event.target);
      mountVideos(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
